import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import { StyleSheet } from "react-native";
import CourseGeneratorSettings from "../../../components/customCoursework/CourseGeneratorSettings/CourseGeneratorSettings";

interface CourseGeneratorSettingsModalContainerProps {
  visible: boolean;
  onClose: () => void;
  isSubmitting: boolean;
  onGenerateCourse: (numberOfModules: number, numberOfActivities: number, courseDescription: String) => void;
}

const CourseGeneratorSettingsModalContainer = ({
  visible,
  onClose,
  onGenerateCourse,
}: CourseGeneratorSettingsModalContainerProps) => {
  const handleClose = () => {
    onClose();
  };

  const handleGenerateCourse = (data) => {
    onGenerateCourse(data.numberOfModules, data.numberOfActivities, data.courseDescription);
    onClose();
  };

  return (
    <CustomModal visible={visible} onRequestClose={handleClose} showCloseButton={false} style={styles.modal}>
      <CourseGeneratorSettings onSubmit={handleGenerateCourse} onCancel={handleClose} isSubmitting={false} />
    </CustomModal>
  );
};

const styles = StyleSheet.create({
  modal: {
    margin: 10,
    maxHeight: "100%",
    width: "100%",
    maxWidth: "65%",
    padding: 0,
    alignSelf: "center",
  },
});

export default CourseGeneratorSettingsModalContainer;
